import React, {useEffect} from 'react'
import OASUI from './oas-ui'
import RedocUI from './redoc-ui'
import {Button, Dropdown, Modal} from 'semantic-ui-react'
import {asOptions} from '../../../../util'
import {useSafeState} from '../../../../hook'

const _VersionDocsPreview = (
  {
    contract = {definition: ''},
    display = 'api-docs',
    onClose
  }
) => {
  const [_display, setDisplay] = useSafeState('oas')

  useEffect(() => {
    setDisplay(display)
  }, [contract, display])

  return (
    <div>
      <Modal size='fullscreen' open={true} closeOnDimmerClick={true} closeIcon={true} onClose={onClose} data-testid='version-docs-preview-modal'>
        <Modal.Header>
          Docs
        </Modal.Header>
        <Modal.Content>
          <div style={{marginBottom: '15px'}}>
            <Dropdown selection
                      options={asOptions(['swagger-docs', 'api-docs'])}
                      value={_display}
                      data-testid='version-docs-preview-as-dropdown'
                      onChange={(e, d) => setDisplay(d.value)}/>
          </div>
          {
            _display === 'api-docs' && (<RedocUI contract={contract}/>)
          }
          {
            _display === 'swagger-docs' && (<OASUI contract={contract}/>)
          }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} data-testid='version-docs-preview-close-button'>Close</Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const VersionDocsPreview = (props) => {
  return (<_VersionDocsPreview {...props}/>)
}

export {_VersionDocsPreview, VersionDocsPreview}

export default VersionDocsPreview